import React from 'react';
import { FolderOpen, Users, Calendar, Search } from 'lucide-react';

const Features = () => {
  const features = [
    {
      icon: <FolderOpen className="w-8 h-8" />,
      title: "Repositório de materiais",
      description: "Atividades, provas, jogos e exercícios organizados por série e disciplina.",
      color: "bg-purple-100 text-purple-600"
    },
    {
      icon: <Users className="w-8 h-8" />,
      title: "Compartilhamento entre professores",
      description: "Veja o que está funcionando em outras salas de aula e contribua também.",
      color: "bg-blue-100 text-blue-600"
    },
    {
      icon: <Calendar className="w-8 h-8" />,
      title: "Planejamento de aulas",
      description: "Monte planos semanais ou por tema, sem complicação.",
      color: "bg-orange-100 text-orange-600"
    },
    {
      icon: <Search className="w-8 h-8" />,
      title: "Busca fácil",
      description: "Encontre materiais rapidamente, sem perder tempo.",
      color: "bg-green-100 text-green-600"
    }
  ];

  return (
    <section className="py-24 bg-gray-50">
      <div className="container mx-auto px-4 md:px-8">
        <div className="text-center max-w-3xl mx-auto mb-20">
          <span className="text-sm font-bold text-purple-600 uppercase tracking-widest mb-4 block">⚙️ Como o Sôra Ajuda</span>
          <h2 className="font-hero text-4xl md:text-5xl">Explore Nossas Soluções</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="bg-white p-10 rounded-[2.5rem] shadow-sm hover:shadow-xl transition-all group border border-gray-100 flex flex-col h-full">
              <div className={`w-16 h-16 ${feature.color} rounded-2xl flex items-center justify-center mb-8 group-hover:scale-110 transition-transform`}>
                {feature.icon}
              </div>
              <h3 className="text-xl font-bold mb-4">{feature.title}</h3>
              <p className="text-gray-600 leading-relaxed flex-grow">{feature.description}</p>
              <div className="mt-8 pt-6 border-t border-gray-50">
                <button className="text-purple-600 font-bold flex items-center gap-2 group/btn">
                  Saber mais
                  <span className="group-hover/btn:translate-x-1 transition-transform">→</span>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;

